module.exports = __webpack_public_path__ + "img/logo-circle.1ef5f3c2.svg";